/** Marks an illustrative panel whose content is sample data, not the visitor's own. */
export function ExampleLabel() {
  return (
    <div
      className="example-label"
      style={{
        display: "inline-block",
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "var(--v6-fg-muted)",
        border: "1px solid var(--v6-hair-strong)",
        borderRadius: 9999,
        padding: "2px 10px",
        marginBottom: 8,
      }}
    >
      Example
    </div>
  );
}
